interface IMessageConstant {
  TAG: {
    DROPSHIPPING: string;
  };
}

const MESSAGE: IMessageConstant = {
  TAG: {
    DROPSHIPPING: 'Dropshipping',
  },
};

export default MESSAGE;
